module.exports = __webpack_public_path__ + "img/header-success.b3a36ba0.png";